/**
 * @author       [Tim Vermaelen]
 * @date         [2016-2022]
 * @link         [http://www.adequatelygood.com/JavaScript-Module-Pattern-In-Depth.html]
 * @namespace    [Blastic]
 * @requires     [jQuery]
 * @revision     [0.7]
 */

// @param ($): jQuery
// @param (ns): namespace
window.Blastic = (function ($, ns) {

    // 1. ECMA-262/5
    'use strict';

    // 2. PRIVATE CONFIGURATION OVERRIDE
    const cfg = {};

    // 3. LOAD COMPONENTS
    ns.components = function () {
        ns.Cookiebox.init();
        ns.LanguageSwitcher.init();
        ns.Forms.init();
        ns.Navigation.init();
        //ns.Dom.init();
    };

    // 4. LOAD CLASSES
    ns.classes = function () {
        return {
            
        };
    };

    // 5. ONCE THE DOM IS READY
    $(function () {
        ns.components();
        ns.classes();
    });

    window.addEventListener('load', () => {
        ns.Dom.init();
    });

    // 6. GLOBALIZE NAMESPACE
    return ns;

})(window.jQuery, window.Blastic || {});
